var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('template',{slot:"renderEmpty"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"280px"},attrs:{"src":require("../assets/original.png"),"alt":""}}),_c('p',[_vm._v("暂无数据")])])]),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }